module.exports = __webpack_public_path__ + "img/vehicular_multas_100_agosto.9fe07dae.png";